import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { UserFormValues } from "src/models/User.model";
import { useAddUserMutation } from "src/services/UserServices";
import { showToast } from "src/utils/showToaster";
import { validPhoneRegex } from "src/utils/validations/numberInput";
import { array, object, string } from "yup";
import UserForm from "../Layouts/UserForm";

type Props = {
  onClose: () => void;
};

const AddUserFormWrapper = ({ onClose }: Props) => {
  const [addUser] = useAddUserMutation();
  // Form Initial Values
  const initialValues: UserFormValues = {
    firstName: "",
    lastName: "",
    userName: "",
    mobile: "",
    email: "",
    password: "",
    userRole: "",
    userType: "CDT_USER",
    branches: [],
  };

  // Validation Schema
  const validationSchema = object().shape({
    firstName: string().required("Please enter first name"),
    lastName: string().required("Please enter last name"),
    userName: string().required("Please enter username"),
    email: string().email().required("Please enter email"),
    password: string().required("Please enter password"),
    mobile: string()
      .matches(validPhoneRegex, "Please enter valid number")
      .required("Please enter mobile"),
    userRole: object().required("Please select role"),
    branches: array().min(1, "Please select branch"),
  });

  // Handle Submit
  const handleSubmit = (
    values: UserFormValues,
    { setSubmitting, resetForm }: FormikHelpers<UserFormValues>
  ) => {
    const formattedValues = {
      ...values,
      userRole: values?.userRole?.value,
      branches: values?.branches?.map((role: any) => {
        return role?.value;
      }),
    };
    addUser(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <UserForm
              formikProps={formikProps}
              onClose={onClose}
              formType={"Add"}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddUserFormWrapper;
